'use client';

import * as React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';

import { cn, formatCurrency } from '@/lib/utils';
import { useEffect } from 'react';
type CustomSliderProps = React.ComponentPropsWithoutRef<
  typeof SliderPrimitive.Root
> & {
  callback?: (value: number) => void; // Add your custom parameter here
};
const Slider = React.forwardRef<
  React.ElementRef<typeof SliderPrimitive.Root>,
  CustomSliderProps
>(({ className, ...props }, ref) => {
  const [value, setValue] = React.useState(0);
  const onValueChange = (text: number) => {
    setValue(text);
    if (props.callback) {
      props.callback(text);
    }
  };

  useEffect(() => {
    setValue(value ?? 0);
    if (props.callback) {
      props.callback(value ?? 0);
    }
  }, [value]);

  return (
    <SliderPrimitive.Root
      onValueChange={(text) => onValueChange(text)}
      ref={ref}
      className={cn(
        'relative flex w-full touch-none select-none items-center',
        className,
      )}
      {...props}
    >
      <SliderPrimitive.Track className="relative h-2 w-full grow overflow-hidden rounded-full bg-light">
        <SliderPrimitive.Range className="absolute h-full bg-secondary" />
      </SliderPrimitive.Track>
      {/* <h5 className="absolute bottom-4 right-1"> {formatCurrency(value)}</h5> */}
      <SliderPrimitive.Thumb className="focus-visible:ring-ring block h-5 w-5 rounded-xl border bg-background ring-offset-background transition-colors focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50"></SliderPrimitive.Thumb>
    </SliderPrimitive.Root>
  );
});
Slider.displayName = SliderPrimitive.Root.displayName;

export { Slider };
